import { render, staticRenderFns } from "./ModalCancelaMatricula.vue?vue&type=template&id=ddf95fd4"
import script from "./ModalCancelaMatricula.vue?vue&type=script&lang=js"
export * from "./ModalCancelaMatricula.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports